import { Component, OnInit, Inject } from '@angular/core';
import { UserAccessType, AuthorizedUserAccessType } from '../models/user.model';
import { UserServiceIdentity } from '../services/user.service';
import { DealershipService } from '../services/dealership.service';
import { DealershipOverview, BrandedStyle, DealerGroupV, JobsiteV, JobsiteOverviewModel } from '../models/dealership.model';
import { CustomerServiceIdentity } from '../services/customer.service';
import { AppService } from '../../../app.service';
import { CustomerOverview } from '../models/customer.model';
import { JobRole, User } from '../models/user.model';
import { NotificationsService } from 'angular2-notifications';
import { AssignmentType } from '../models/access.model';
import { PreferencesService } from '../../preferences/preferences.service';
import { LanguageViewModel } from '../../preferences/models/preferences.model';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CryptoService } from '../../../services/crypto.service';
import { UserService } from '../../../shared/services/user.service';
@Component({
  selector: 'add-user-modal',
  templateUrl: './add-user-modal.component.html',
  styleUrls: ['./add-user-modal.component.scss']
})
export class AddUserModalComponent implements OnInit {
  savingNewUser = false;
  accessTypes: AuthorizedUserAccessType[];
  dealerships: DealershipOverview[];
  dealergroups: DealerGroupV[];
  jobsites: JobsiteOverviewModel[];
  customers: CustomerOverview[];
  jobRoles: JobRole[];
  ShowAlertTab: number = 1;
  email = '';
  name = '';
  phone = '';
  USI = ''
  username = '';
  pass = '';
  selectedCustomerId = 0;
  selectedDealershipId = 0;
  selectedDealerGroupId = 0;
  selectedJobsiteId = 0;
  styles: BrandedStyle[];
  showSelectBrandedSite = false;
  selectedStyleId = 0;
  userInitals = '';
  allowCheckUndercarriageAccess = false;
  allowCheckGetAccess = false;

  undercarriageEnabled = false;
  getEnabled = false;
  safetyEnabled = false;


  userAccessType: UserAccessType;
  selectedAccessTypeId: number;
  selectCustomerRequired = false;
  selectDealershipRequired = false;
  selectAccessToCustomersRequired = false;
  selectDealershipGroupRequired = false;
  selectJobsiteRequired = false;
  languagesList: LanguageViewModel[];

  selectedLanguageId: number = 1;
  customerAccessDropdownList = [];
  customerAccessDropdownSettings = {
    singleSelection: false,
    text: 'Select Customers',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    enableSearchFilter: true,
    classes: 'multiselect-dropdown multiselect-dropdown--center',
    maxHeight: 150,
    badgeShowLimit: 6
  };
  customerAccessSelectedItems = [];

  jobRoleDropdownList = [];
  jobRoleDropdownSettings = {
    singleSelection: false,
    text: 'Select Job Roles',
    selectAllText: 'Select All',
    unSelectAllText: 'Un-select All',
    enableSearchFilter: true,
    classes: 'multiselect-dropdown multiselect-dropdown--center',
    maxHeight: 150,
    badgeShowLimit: 8
  };
  jobRoleSelectedItems = [];
  BrandStyle: string = "";
  subscriptions: any;
  DeafultUCSetupType: number;
  loginMethod: string = 'Default';
  showLoginMethod: boolean = false;
  SSOEnabled: boolean = false;

  constructor(public dialogRef: MatDialogRef<AddUserModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _userService: UserServiceIdentity,
    private _dealershipService: DealershipService,
    private _customerService: CustomerServiceIdentity,
    private _appService: AppService,
    private readonly _pref: PreferencesService,
    private _notification: NotificationsService,
    private crypto: CryptoService, private _user: UserService) { }
  ngOnInit() {
    this._userService.getUserAccessType().subscribe(response => {
      this.userAccessType = response;
    });
    this._userService.getAuthorizedUserAccessTypes().subscribe(response => {
      this.accessTypes = response;
    });
    this._dealershipService.getAllDealerships().subscribe(response => {
      this.dealerships = response;
    });
    this._dealershipService.getAllDealerGroups().subscribe(response => {
      this.dealergroups = response;
    });

    this._dealershipService.getAllJobsites().subscribe(response => {
      this.jobsites = response;
    });

    this._customerService.getAllCustomers().subscribe(response => {
      this.customers = response;
    });
    this._userService.getAssignableJobRoles().subscribe(response => {
      this.jobRoleDropdownList = response;
      // response.forEach(r => {
      //     // this.jobRoleDropdownList.push({
      //     //     'id': r.Id,
      //     //     'itemName': r.Name
      //     // });
      // });
    });

    this._userService.getAllLanguages().subscribe(result => {
      this.languagesList = result;
    });

    this.checkPermissions();
    this.handleCheckApplicationAccess();
    this.pass = '';
    this.ShowSignInMethodOptions();

  }

  ShowSignInMethodOptions() {
    this._appService.getApplicationConfiguration("ShowSignInMethodOptions").subscribe(result => {
      this.showLoginMethod = result;
      if (result) {
        this._appService.SSOEnabled().subscribe(result => {
          this.SSOEnabled = result;
        });
      }
    });
  }

  showAlertFiled: boolean = false;
  checkPermissions() {
    this._user.getUserJobRoles().subscribe(
      jobRoles => {
        jobRoles.forEach(role => {
          switch (role.Name) {
            case 'Inspectors':
              this.showAlertFiled = true;
              break;
            case 'Interpreters':
            case 'Super User':
            case 'Administrator':


              break;
            case 'Customer Admin':

              break;
          }
        });
      },
      error => {
        console.error(error);

      }
    );
  }
  updateRequiredSelections() {
    if (+this.selectedAccessTypeId === +AssignmentType.SupportUser) {
      this.selectCustomerRequired = false;
      this.selectDealershipRequired = false;
      this.selectAccessToCustomersRequired = false;
      this.selectDealershipGroupRequired = false;
      this.selectJobsiteRequired = false;
    } else if (+this.selectedAccessTypeId === +AssignmentType.DealerGroupUser) {
      this.selectCustomerRequired = false;
      this.selectDealershipRequired = false;
      this.selectDealershipGroupRequired = true;
      this.selectAccessToCustomersRequired = false;
      this.selectJobsiteRequired = false;
    } else if (+this.selectedAccessTypeId === +AssignmentType.DealerUser) {
      this.selectCustomerRequired = false;
      this.selectDealershipRequired = true;
      this.selectAccessToCustomersRequired = false;
      this.selectDealershipGroupRequired = false;
      this.selectJobsiteRequired = false;
    } else if (+this.selectedAccessTypeId === +AssignmentType.CustomerUser) {
      this.selectCustomerRequired = true;
      this.selectDealershipRequired = false;
      this.selectAccessToCustomersRequired = false;
      this.selectDealershipGroupRequired = false;
      this.selectJobsiteRequired = false;
    } else if (+this.selectedAccessTypeId === +AssignmentType.JobsiteUser) {
      this.selectCustomerRequired = false;
      this.selectDealershipRequired = false;
      this.selectAccessToCustomersRequired = false;
      this.selectDealershipGroupRequired = false;
      this.selectJobsiteRequired = true;
    }
    this.updatePossibleStyleList();
    console.log(this.selectedAccessTypeId);
  }

  handleCheckApplicationAccess() {
    this._appService.getGetUrl().subscribe(response => {
      this.getEnabled = response.length > 0 ? true : false;
      this.allowCheckGetAccess = response.length > 0 ? true : false;
    });

    this._appService.getUndercarriageUrl().subscribe(response => {
      this.undercarriageEnabled = response.length > 0 ? true : false;
      this.allowCheckUndercarriageAccess = response.length > 0 ? true : false;
    });
  }

  onSelectDealership() {
    this._customerService.getAllCustomersForDealership(this.selectedDealershipId).subscribe(response => {
      this.customerAccessDropdownList = [];
      this.customerAccessSelectedItems = [];
      response.forEach(r => {
        this.customerAccessDropdownList.push({
          'id': r.CustomerId,
          'itemName': r.CustomerName
        });
      });
    });
    this.updatePossibleStyleList();
  }

  updatePossibleStyleList() {
    let teamId = 0;
    if (this.selectedAccessTypeId === 2 || this.selectedAccessTypeId === 3) {
      teamId = this.selectedDealershipId;
    } else if (this.selectedAccessTypeId === 4 || this.selectedAccessTypeId === 5) {
      teamId = this.selectedCustomerId;
    }
    this._dealershipService.getPossibleBrandedStylesForNewUser(this.selectedAccessTypeId, teamId).subscribe(response => {
      this.styles = response;
      if (this.styles.length > 1) {
        this.showSelectBrandedSite = true;
      } else {
        this.showSelectBrandedSite = false;
      }
    });
  }

  addNewUser() {
    if (this.savingNewUser) {
      return;
    }

    if (!this.styles || this.styles.length === 0) {
      this.selectedStyleId = 0;
    } else if (this.styles.length === 1) {
      this.selectedStyleId = this.styles[0].Id;
    }

    const newUser: User = {
      //AES256
      Name: this.crypto.encrypt(this.name?.trim()),
      UserName: this.crypto.encrypt(this.username?.trim()),
      Email: this.crypto.encrypt(this.email?.trim()),
      Password: this.crypto.encrypt(this.pass),
      Phone: (this.phone && this.phone.trim().length > 0) ? this.crypto.encrypt(this.phone) : '',
      // Name: this.name,
      // Email: this.email,
      // UserName: this.username,
      // Password: this.password,
      // Phone: this.phone,
      AccessTypeId: this.selectedAccessTypeId,
      CustomerId: this.selectCustomerRequired ? this.selectedCustomerId : null,
      DealershipId: this.selectDealershipRequired ? this.selectedDealershipId : null,
      AccessCustomerIds: this.selectAccessToCustomersRequired ? this.customerAccessSelectedItems.map(c => c.id) : null,
      DealerGroupId: this.selectDealershipGroupRequired ? this.selectedDealerGroupId : null,
      JobsiteId: this.selectJobsiteRequired ? this.selectedJobsiteId : null,
      Id: 0,
      JobRoles: this.jobRoleSelectedItems,
      UndercarriageEnabled: this.undercarriageEnabled,
      GetEnabled: this.getEnabled,
      StyleId: this.selectedStyleId,
      safetyEnabled: this.safetyEnabled,
      USI: this.USI,
      LanguageId: this.selectedLanguageId,
      UCSetupType: this.DeafultUCSetupType,
      UserInitials: this.userInitals,
      ShowAlertTab: this.ShowAlertTab,
      SigninMethod: this.loginMethod
    };

    if (newUser.Name.length === 0 || newUser.UserName.length === 0 ||
      newUser.Email.length === 0 || newUser.AccessTypeId === 0 ||
      newUser.AccessTypeId == null || newUser.JobRoles == null ||
      newUser.JobRoles.length === 0 || (newUser.UndercarriageEnabled !== true && newUser.GetEnabled !== true && newUser.safetyEnabled !== true)) {
      this._notification.error('Missing Required Field (*)', 'Please fill in all required fields before sending the invite. ');
      return;
    }
    if (newUser.Password.length < 3) {
      this._notification.error('Invalid Password', 'Passord must be at least 3 characters. ');
      return;
    }
    if (newUser.AccessTypeId === 2 && newUser.DealerGroupId === 0) {
      this._notification.error('Missing Required Field (*)', 'Please fill in all required fields before sending the invite. ');
      return;
    }
    if (newUser.AccessTypeId === 3 && newUser.DealershipId === 0) {
      this._notification.error('Missing Required Field (*)', 'Please fill in all required fields before sending the invite. ');
      return;
    }
    if (newUser.AccessTypeId === 4 && (newUser.CustomerId == null || newUser.CustomerId === 0)) {
      this._notification.error('Missing Required Field (*)', 'Please fill in all required fields before sending the invite. ');
      return;
    }
    if (newUser.AccessTypeId === 5 && (newUser.JobsiteId == null || newUser.JobsiteId === 0)) {
      this._notification.error('Missing Required Field (*)', 'Please fill in all required fields before sending the invite. ');
      return;
    }

    this.savingNewUser = true;
    this._userService.createNewUser(newUser).subscribe(response => {
      this.savingNewUser = false;
      if (response.Item1) {
        this._notification.success('User Added', response.Item2);
        console.log(response);
        this.dialogRef.close(true);
      } else {
        this._notification.error('Failed', response.Item2);
        console.log(response);
      }
    });
  }
  Validate(event: any) {
    var regex = new RegExp("^[0-9-()+ ]");
    var key = String.fromCharCode(event.charCode ? event.which : event.charCode);
    if (!regex.test(key)) {
      event.preventDefault();
      return false;
    }
  }
  onNoClick(): void {
    this.dialogRef.close();
  }

  GetBrandStyle(selectedID: number) {
    this._userService.GetBrandStyle(selectedID, this.selectedAccessTypeId).subscribe(res => {
      this.BrandStyle = res;
    })
  }

  setInitialsFromName(): void {
    if (this.name) {
      const words = this.name.trim().split(/\s+/);
      this.userInitals = words.map(w => w[0]?.toUpperCase()).join('').slice(0, 2);
    }
  }
}
